var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.32 20.28a5.01 5.01 0 0 0-2.54-.7c-.42 0-.83.05-1.25.16-2.67.68-4.29 3.41-3.61 6.08s3.4 4.29 6.08 3.61a4.992 4.992 0 0 0 3.6-6.08 4.935 4.935 0 0 0-2.28-3.07zM58.54 3.06c-3.42.42-6.77 1.21-10 2.33 4.9 4.34 9.51 9.03 13.74 13.99 1.19-3.22 2.04-6.62 2.49-10.2.44-3.57-2.66-6.56-6.23-6.12z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.42 6.19c-8.93 3.58-16.7 9.8-21.69 18.26-1.95 3.3-4.16 7.31-4.05 11.24.06 2.06 2.23 3.91 3.52 5.37 1.61 1.82 3.38 3.48 5.33 4.93 1.35 1 3.08 1.4 4.7.97 4.43-1.18 9.2-3.38 12.51-6.14 6.44-5.38 11.53-11.84 14.71-19.32-4.59-5.47-9.63-10.6-15.03-15.31zm3.37 21.96a6.933 6.933 0 0 1-4.29 3.21c-.58.15-1.16.22-1.73.22-3.12 0-5.97-2.11-6.78-5.27-.95-3.74 1.31-7.56 5.05-8.51 1.81-.46 3.69-.19 5.3.76s2.75 2.48 3.21 4.29c.47 1.81.2 3.69-.76 5.3zM18.73 34.35c.31-3.91 2.34-7.66 4.27-10.93.81-1.37 1.69-2.69 2.66-3.96C15.2 20.8 8.65 24.97 2.9 30.9c5.26-.16 11.43.49 15.83 3.45zM34.74 48.88c-.07.02-.14.04-.22.05 1.69 4.82 1.53 8.77 1.92 13.47 7.37-6.95 12.03-12.56 13-21.29-.47.41-.94.82-1.43 1.23-3.29 2.75-8.25 5.19-13.27 6.54zM16.15 44.58a.806.806 0 0 0-.51-.31c-.29-.05-.78-.12-7.56 4.95-6.78 5.08-6.84 5.57-6.88 5.86-.03.2.03.42.16.58.14.17.25.32.49.32.65 0 2.22-.98 7.56-4.98 7.38-5.53 7.21-5.77 6.74-6.42zM17.18 51.54c1.57-1.91 1.52-2.47 1.5-2.65a.926.926 0 0 0-.29-.56c-.62-.51-1.31.13-1.64.43-.38.34-.83.83-1.28 1.37-1.9 2.31-1.64 2.85-1.21 3.21.14.11.29.2.49.2.44.01 1.13-.42 2.43-2zM22.44 50.17c-.81-.41-.81-.4-4.13 5.37l-.55.95c-3.38 5.88-3.38 5.88-2.62 6.37a.796.796 0 0 0 .6.1c.96-.23 3.86-5.23 4.18-5.79.13-.23 3.2-5.57 2.91-6.53a.795.795 0 0 0-.39-.47zM22.7 42.38l-.71-.77c-.8-.84-1.69-1.8-2.36-2.9-.56 2.53-.47 5.24 1.24 7.3 1.64 1.98 4.73 1.99 7.4 1.54a38.431 38.431 0 0 1-5.57-5.17z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrash);
export default __webpack_public_path__ + "static/media/icon-crash.914e27baf38391d72b09223bb4b5c4fb.svg";
export { ForwardRef as ReactComponent };